import { DeleteOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import { notification, Select, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import { Close, CloseModal } from "../../../components/icons";
import { acceptedFilesSize } from "../../../config";
import { ENTITY_TYPE, nameValidator } from "../../../constants/phase";
import { isValidStream } from "../../../store/videogrid/api";
import { getContentType } from "../../../store/videogrid/api";
import { getWorkspaceConfig } from "../../../store/workspaceConfig/api";
import { folderValidationSchema } from "../../../utils/validations";
import ManageAccess from "../ManageAccess/manageAccess";
import PreSignedUpload from "../PreSignedUrl/preSignedUpload";

const UploadModal = (props) => {
  const {
    openDropZone,
    setOpenDropZone,
    onChange,
    folder,
    selectedFolder,
    setSelectedFolder,
    onSubmit,
    acceptType,
    uploadLoader,
    getTimeLineDuration,
    fileType,
    component,
    uploadFileData,
    setUploadFileData,
    workspaceFolders,
    setWorkspaceFolders,
  } = props;
  const { Option } = Select;
  const initialState = {
    uploadUrl: "",
    title: "",
    outcome: [],
  };
  const { workspaces, entityType } = useOutletContext();
  const [progress, setProgress] = useState();
  const [disableEdit, setDisableEdit] = useState(false);
  const [urlForValidation, setUrlForValidation] = useState("");
  const [isvalidShowMessage, setIsvalidShowMessage] = useState({});
  const [totalFilesSize, setTotalFilesSize] = useState(acceptedFilesSize);
  const [uploadFilesLength, setUploadFilesLength] = useState([]);
  const [uploading, setUploading] = useState(false);

  const initialWorkspaceFolder = {
    workspaces,
    workspacesFolders: [],
    selectedFolderId: "",
    selectedWorkspaceId: "",
  };

  const getWorkSpaceConfigData = async () => {
    const tempWorkSpace = await Promise.all(
      workspaces?.map(async (workspace) => {
        const { data } = await getWorkspaceConfig(workspace.workspaceId);
        return { ...workspace, folder_name: data?.folder_name || [] };
      }),
    );
    if (workspaces.length) {
      setWorkspaceFolders([{ ...initialWorkspaceFolder, workspaces: tempWorkSpace }]);
    }
  };
  useEffect(() => {
    if (workspaces && setWorkspaceFolders && getWorkspaceConfig) {
      getWorkSpaceConfigData();
    }
  }, [workspaces, setWorkspaceFolders, getWorkspaceConfig, openDropZone]);

  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;

  const fileProgress = useRef({ files: {}, totalSize: 0, xhrs: [] });

  const onChangeFolder = (e, setFieldValue) => {
    setSelectedFolder(e);
    setFieldValue("outcome", e);
  };

  const setTitle = async (fileIndex, fileSize, objDataReset) => {
    const { values, resetForm, setFieldValue } = objDataReset;
    let arrNewTempData = uploadFileData.filter((item, index) => fileIndex !== index);
    if (component === "thumbnailLogo" || component === "sound" || arrNewTempData.length === 0) {
      resetForm({ values });
      setUrlForValidation("");
      setSelectedFolder([]);
      setProgress(0);
      setUploadFileData([]);
      setTotalFilesSize(acceptedFilesSize);
    } else {
      setTotalFilesSize(totalFilesSize + fileSize);
      setUploadFileData(arrNewTempData);
      if (arrNewTempData.length === 1) {
        setFieldValue(`uploadUrl`, arrNewTempData[0].uploadFileUrl);
        setFieldValue(`title`, arrNewTempData[0].fileName);
      }
    }
    setUploadFilesLength(uploadFilesLength - 1);
  };

  const closeModal = () => {
    if (fileProgress.current.xhrs) {
      fileProgress.current.xhrs.forEach((xhr) => xhr.abort());
    }
    setProgress(0);
    setOpenDropZone(false);
    setSelectedFolder([]);
    setDisableEdit(false);
    setUrlForValidation("");
    setUploadFileData([]);
    setUploadFilesLength(0);
    setTotalFilesSize(acceptedFilesSize);
    setWorkspaceFolders([
      { workspaces: workspaces, workspacesFolders: [], selectedFolderId: "", selectedWorkspaceId: "" },
    ]);
  };

  const handleUpload = () => {
    onSubmit();
    setProgress(0);
    setDisableEdit(false);
    setOpenDropZone(false);
    setUploadFilesLength(0);
    notification["success"]({ message: "File uploading has been initiated." });
    setWorkspaceFolders([
      { workspaces: workspaces, workspacesFolders: [], selectedFolderId: "", selectedWorkspaceId: "" },
    ]);
  };

  useEffect(() => {
    if (urlForValidation) {
      setIsvalidShowMessage({ status: true, message: "Validating URL please wait…" });

      const timer = setTimeout(() => {
        validateUrl(urlForValidation);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [urlForValidation]);

  const validateUrl = async (url) => {
    const regex = new RegExp(/\.(jpg|jpeg|png)$/);

    let { contentType, contentlength } = await getContentType({ url });
    let size = contentlength / 1048576; // 1048576 is bytes in 1MB
    if (size >= 100) {
      setIsvalidShowMessage({ message: `file size should not exceed 100 MB.` });
      return;
    }

    if (contentType && fileType && fileType.includes(contentType.split("/")[1])) {
      let name = url
        .split("/")
        ?.pop()
        ?.replace(/\.[^/.]+$/, "");
      let check = true;

      if (
        (contentType.split("/")[0] === "video" || contentType.split("/")[1] === "octet-stream") &&
        component === "bumper"
      ) {
        const isValidUrl = await isValidStream({ url, sei_check: false, checkDimensions: false });
        if (!isValidUrl?.success) {
          check = false;
          setIsvalidShowMessage({ message: "Invalid url" });
        }
        contentType = "video/mp4";
      }

      if (contentType.split("/")[1] === "octet-stream" && component === "logo") {
        if (!regex.test(url)) {
          check = false;
          setIsvalidShowMessage({ message: "Invalid url" });
        }
        contentType = "audio/mp3";
      }

      if (check) {
        setIsvalidShowMessage({});
        let value = [
          {
            fileType: contentType.split("/")[0],
            isAudio: false,
            fileSize: contentlength,
            uploadFileUrl: url,
            uploadUrlTitle: nameValidator(name.split(".")[0]),
            fileName: nameValidator(name),
          },
        ];
        onChange(value);
        setTotalFilesSize(totalFilesSize - contentlength);
      }
    } else {
      setIsvalidShowMessage({ message: "Invalid url" });
    }
  };
  const addWorkspaceFolders = (e, index) => {
    const folders = workspaceFolders[0]?.workspaces.find(({ workspaceId }) => workspaceId === e);
    const workspace = {
      ...workspaceFolders[index],
      workspacesFolders: folders?.folder_name || [],
      selectedWorkspaceId: e,
      selectedFolderId: "", // Clear selectedFolderId when changing selectedWorkspaceId
    };
    setWorkspaceFolders([...workspaceFolders?.slice(0, index), workspace, ...workspaceFolders.slice(index + 1)]);
  };

  const setFolder = (e, index) => {
    setWorkspaceFolders(
      workspaceFolders.map((workspace, i) => (i === index ? { ...workspace, selectedFolderId: e } : workspace)),
    );
  };
  const handleRemoveWorkSpaceFolder = (index) => {
    let tempArray = [...workspaceFolders];
    tempArray.splice(index, 1);
    setWorkspaceFolders(tempArray);
  };
  const handleAddAditionalField = () => {
    if (workspaceFolders?.length == 0) {
      getWorkSpaceConfigData();
    } else {
      setWorkspaceFolders([
        ...workspaceFolders,
        {
          ...workspaceFolders[0],
          workspacesFolders: [],
          selectedFolderId: "",
          selectedWorkspaceId: "",
        },
      ]);
    }
  };

  return (
    <Modal
      isOpen={openDropZone}
      onRequestClose={() => setOpenDropZone(false)}
      shouldCloseOnOverlayClick={false}
      contentLabel="Filter Modal"
      portalClassName="react-modal"
      overlayClassName="modal"
      className="modal-dialog react-modal-dialog-sm modal-dialog-centered"
    >
      <Formik
        enableReinitialize
        initialValues={initialState}
        validationSchema={component === "sound" || component === "thumbnailLogo" ? folderValidationSchema : null}
        onSubmit={handleUpload}
      >
        {({ errors, touched, setFieldValue, values, resetForm }) => (
          <div className="modal-content">
            <Form>
              <div className="react-modal-header">
                <h5 className="react-modal-title">Upload File</h5>
                <button type="button" className="btn btn__default" onClick={() => closeModal()}>
                  <CloseModal />
                </button>
              </div>
              <div className="react-modal-body upload-video-dropzone-modal">
                <div className="form-container ">
                  {openDropZone && (
                    <PreSignedUpload
                      storageId={""}
                      storage_name={""}
                      getTimeLineDuration={getTimeLineDuration}
                      setFieldValue={setFieldValue}
                      setUploadFilesLength={setUploadFilesLength}
                      uploadFilesLength={uploadFilesLength}
                      acceptFileType={acceptType}
                      fileType={fileType}
                      isResourceBucket={true}
                      callBackFun={onChange}
                      progress={progress}
                      setProgress={setProgress}
                      uploadingFileSize={100}
                      setTotalFilesSize={setTotalFilesSize}
                      totalFilesSize={totalFilesSize}
                      setDisableEdit={setDisableEdit}
                      component={component}
                      setUploading={setUploading}
                      uploading={uploading}
                      openDropZone={openDropZone}
                      fileProgress={fileProgress}
                    />
                  )}

                  <div className="text-center ">OR</div>
                  <label className="form-label">
                    URL <span className="required">*</span>{" "}
                    <span className="uploadClip-subtitle">
                      Please add URL, File must not be larger than 100 MB ({fileType.join(", ")})
                    </span>
                  </label>
                  {uploadFileData && uploadFileData.length > 1 ? (
                    uploadFileData.map((item, index) => {
                      return (
                        <div className="bottom-border-container" key={index}>
                          <Field
                            className="form-control"
                            name={`uploadUrl__${item.uploadUrlTitle}`}
                            type="text"
                            disabled={disableEdit}
                            value={item.uploadFileUrl}
                          />
                          <div className="form-group">
                            <label className="form-label">
                              Title <span className="required">*</span>
                            </label>
                            <div className="form-pop-trigger-block">
                              <Field
                                className="form-control"
                                type="text"
                                value={item.uploadUrlTitle}
                                disabled={disableEdit}
                                name={`title_${item.uploadUrlTitle}`}
                                placeholder="Title"
                              />
                            </div>
                            {!touched[`title_${item.uploadUrlTitle}`] && !errors[`title_${item.uploadUrlTitle}`] && (
                              <div className="invalid-feedback">
                                {touched[`title_${item.uploadUrlTitle}`]}
                                {touched[`uploadUrl_${item.uploadUrlTitle}`]}
                              </div>
                            )}
                          </div>
                          {item.uploadFileUrl !== "" && item.uploadUrlTitle !== "" && (
                            <div className="dropzone-title">
                              {item.uploadUrlTitle ? item.uploadUrlTitle : null}
                              <button
                                type="button"
                                className="btn btn__default"
                                onClick={() => {
                                  // setFieldValue(`uploadUrl_${item.fileName}`, '');
                                  // setFieldValue(`title_${item.fileName}`, '');
                                  setTitle(index, item.fileSize, { values, resetForm, setFieldValue });
                                }}
                              >
                                <DeleteOutlined style={{ fontSize: "24px" }} />
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <>
                      <Field
                        className="form-control"
                        name="uploadUrl"
                        type="text"
                        value={values.uploadUrl}
                        disabled={disableEdit}
                        onChange={(e) => {
                          setUrlForValidation(e.target.value);
                          setFieldValue("uploadUrl", e.target.value);
                        }}
                      />
                      {touched.uploadUrl && errors.uploadUrl ? (
                        <div className="invalid-feedback">{errors.uploadUrl}</div>
                      ) : values.uploadUrl.length && !_.isEmpty(isvalidShowMessage) ? (
                        <div className="invalid-feedback" style={isvalidShowMessage.status && { color: "orange" }}>
                          {isvalidShowMessage.message}
                        </div>
                      ) : null}
                      <div className="form-group">
                        <label className="form-label">
                          Title <span className="required">*</span>
                        </label>
                        <div className="form-pop-trigger-block">
                          <Field
                            className="form-control"
                            type="text"
                            name="title"
                            placeholder="Title"
                            onChange={(e) => {
                              setFieldValue("title", e.target.value);
                              uploadFileData[0].uploadUrlTitle = e.target.value;
                            }}
                            disabled={uploadFileData.length === 0 ? true : false}
                          />
                        </div>
                        {touched.title && errors.title && <div className="invalid-feedback">{errors.title}</div>}
                        {uploadFileData && uploadFileData.length > 0
                          ? uploadFileData[0].uploadFileUrl !== "" &&
                            uploadFileData[0].uploadUrlTitle !== "" && (
                              <div className="dropzone-title">
                                {uploadFileData[0].uploadUrlTitle ? uploadFileData[0].uploadUrlTitle : null}
                                <button
                                  type="button"
                                  className="btn btn__default"
                                  onClick={() => {
                                    setTitle(0, 0, { values, resetForm });
                                  }}
                                >
                                  <DeleteOutlined style={{ fontSize: "24px" }} />
                                </button>
                              </div>
                            )
                          : null}
                      </div>
                    </>
                  )}
                </div>
                <div className="custom-checkbox-group-container">
                  <div className="field-container"></div>
                  <div className="checkbox-container-main">
                    <div className="form-group">
                      <label className="form-label">
                        Folders <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="custom-ant-select"
                          name="outcome"
                          value={values.outcome}
                          onChange={(value) => onChangeFolder(value, setFieldValue)}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          mode="multiple"
                          placeholder="Select folders"
                          showSearch
                        >
                          {folder?.length > 0 &&
                            folder.map((folder) => {
                              return <Option value={folder._id}>{folder.name}</Option>;
                            })}
                        </Field>
                      </div>
                    </div>
                  </div>
                </div>
                <ManageAccess value={entityType === ENTITY_TYPE.ORGANIZATION}>
                  {(workspaceFolders || [])?.map((workspace, index) => {
                    return (
                      <>
                        <div className="bg-light-form">
                          {index === 0 && <div className="small-label-t">Send to Workspace information</div>}
                          <div className="addTags--container-row">
                            <div className="field-block field-items">
                              {index === 0 && <label className="form-label">Select workspace</label>}
                              <Select
                                showSearch
                                placeholder="International"
                                optionFilterProp="children"
                                className="custom-ant-select"
                                onChange={(e) => {
                                  addWorkspaceFolders(e, index);
                                }}
                                value={workspace.selectedWorkspaceId}
                                // allowClear={index == 0 ? true : false}
                              >
                                {workspace?.workspaces?.map((workSpace) => {
                                  return (
                                    <Option
                                      disabled={workspaceFolders.find(
                                        ({ selectedWorkspaceId }) => selectedWorkspaceId === workSpace.workspaceId,
                                      )}
                                      value={workSpace.workspaceId}
                                    >
                                      {workSpace.name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </div>
                            <div className="field-block field-items">
                              {index === 0 && <label className="form-label">Select workspace folder</label>}
                              <Select
                                showSearch
                                placeholder="Live video"
                                optionFilterProp="children"
                                className="custom-ant-select"
                                name="videoType"
                                onChange={(e) => {
                                  setFolder(e, index);
                                }}
                                value={workspace.selectedFolderId}
                                // allowClear={index == 0 ? true : false}
                              >
                                {workspace?.workspacesFolders?.map((folder) => {
                                  return <Option value={folder._id}>{folder.name}</Option>;
                                })}
                              </Select>
                            </div>

                            <button
                              type="button"
                              className="add-remove-btn"
                              onClick={() => {
                                handleRemoveWorkSpaceFolder(index);
                              }}
                            >
                              <Close />
                            </button>
                          </div>
                        </div>
                      </>
                    );
                  })}
                  {(workspaceFolders || []).length < workspaces.length && (
                    <button
                      className="add-items-text-btn"
                      type="button"
                      onClick={() => {
                        handleAddAditionalField();
                      }}
                    >
                      + Add Additional
                    </button>
                  )}
                </ManageAccess>
                <div className="react-modal-footer">
                  <button type="button" className="btn btn-white" onClick={() => closeModal()}>
                    Cancel
                  </button>
                  <Spin indicator={antIcon} spinning={uploadLoader}>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={uploadFileData.length > 0 && selectedFolder.length > 0 ? false : true}
                    >
                      Upload
                    </button>
                  </Spin>
                </div>
              </div>
            </Form>
          </div>
        )}
      </Formik>
    </Modal>
  );
};

export default UploadModal;
